<prism-floating-dialog
	id="sh-chat-assistant-prism-dialog"
	#chatComponent
	*transloco="let t; read: 'cloud.shared.chat-assistant'"
	(prismDialogClose)="onDialogClose()"
>
	<span slot="title" id="sh-chat-assistant-prism-dialog-title">
		<div id="sh-chat-assistant-prism-dialog-title-content">
			<prism-icon id="sh-chat-assistant-awesome-icon" icon="auto_awesome"></prism-icon>
			<span id="sh-chat-assistant-prism-dialog-title-text"> {{ t('intellimix-agent') }} </span>
			<span id="sh-chat-assistant-prism-dialog-beta" class="prism-button">{{ t('beta') | uppercase }}</span>
		</div>
	</span>
	<div id="sh-chat-assistant-prism-dialog-body-div">
		<div id="sh-chat-assistant-prism-dialog-new-chat-div">
			<prism-button
				id="sh-chat-assistant-prism-dialog-new-chat-button"
				variant="text"
				size="small"
				(click)="emptyMessageList()"
			>
				{{ t('new-chat') }}
			</prism-button>
		</div>
		<hr id="sh-chat-assistant-prism-dialog-divider" class="prism-divider" orientation="horizontal" />
		<div id="sh-chat-assistant-prism-dialog-messages-list-div" #messagesListDiv>
			<div id="sh-chat-assistant-prism-dialog-message-info-text" class="prism-caption">
				<div id="sh-chat-assistant-reload-warning">{{ t('reload-warning-text') }}</div>
				<div id="sh-chat-assistant-consent-text">{{ t('consent-text') }}</div>
			</div>
			<div id="sh-chat-assistant-prism-dialog-default-message" class="bot-message-style">
				{{ trimResponse(t('default-message')) }}
			</div>
			@for (message of messagesList(); track $index) {
				<ng-container [ngSwitch]="message.type">
					<ng-container *ngSwitchCase="'waiting_for_input'">
						<div id="sh-chat-assistant-prism-dialog-bot-message" class="bot-message-style">
							<prism-radio-group
								id="sh-chat-assistant-radio-group"
								(valueChange)="selectedOption.set($event.detail)"
								[disabled]="$index !== messagesList().length - 1"
							>
								<span slot="group-title" id="sh-chat-assistant-radio-group-title">{{
									t('select-option')
								}}</span>
								@for (option of message.options; track option) {
									<prism-radio-button class="sh-chat-assistant-radio-button" [value]="option">{{
										option
									}}</prism-radio-button>
								}
							</prism-radio-group>
							<div>
								<prism-button
									class="sh-chat-assistant-prism-dialog-option-submit-button"
									variant="bright"
									(click)="submitSelectedOption()"
									[disabled]="
										$index !== messagesList().length - 1 ||
										selectedOption() === '' ||
										isResponseGenerating()
									"
								>
									{{ t('submit') }}
								</prism-button>
							</div>
						</div>
					</ng-container>
					<ng-container *ngSwitchCase="'final_state'">
						@if (message.role === 'user') {
							<div id="sh-chat-assistant-prism-dialog-user-message" class="user-message-style">
								{{ message.content }}
							</div>
						} @else {
							<div class="sh-chat-assistant-prism-dialog-bot-message-container">
								<markdown
									id="sh-chat-assistant-prism-dialog-bot-message"
									[data]="message.content"
									class="bot-message-style"
								>
								</markdown>
								<prism-icon-button
									id="sh-chat-assistant-prism-dialog-copy-button"
									class="sh-chat-assistant-prism-dialog-copy-button"
									icon="content_copy"
									(click)="copyResponseToClipboard(message.content)"
								></prism-icon-button>
							</div>
						}
					</ng-container>
				</ng-container>
			}

			@if (isResponseGenerating()) {
				<div class="bot-message-style" id="sh-chat-assistant-loading-div">
					{{ trimResponse(t('generating-response')) }}
					<span id="sh-chat-assistant-dots" class="loading-dots">
						<span class="dot">.</span>
						<span class="dot">.</span>
						<span class="dot">.</span>
					</span>
				</div>
			} @else if (displayErrorMessage()) {
				<div class="bot-message-style" id="sh-chat-assistant-error-div">
					{{ trimResponse(t('error-message')) }}
				</div>
			}
		</div>
		<div id="sh-chat-assistant-prism-dialog-footer-div">
			<form [formGroup]="formGroup">
				<prism-input
					id="sh-chat-assistant-prism-dialog-input"
					formControlName="chatInput"
					autofocus="true"
					placeholder="{{ t('ask-a-question') }}"
					multiline="true"
					rows="1"
					max-rows="6"
				>
				</prism-input>
				<prism-icon-button
					id="sh-chat-assistant-prism-dialog-send-button"
					[disabled]="formGroup.invalid"
					icon="send"
					(click)="submitMessage()"
				>
				</prism-icon-button>
			</form>
		</div>
	</div>
</prism-floating-dialog>
